import axios from 'axios'
import { deeplyCamelize, deeplySnakize } from 'convert-cases'
import { localeString } from '../plugins/storage.js'
import type { AxiosInstance, AxiosResponse } from 'axios'

export class APIClient {
  private client: AxiosInstance

  constructor(token = '') {
    this.client = this.createClient(token)
  }

  protected async get<R = unknown, P = Record<string, unknown>>(path: string, params?: P): Promise<AxiosResponse<R>> {
    const response = await this.client.get(path, { params: deeplySnakize(params) })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return deeplyCamelize<any, R>(response)
  }

  protected async post<B, R = unknown, P = Record<string, unknown>>(path: string, body?: B, params?: P): Promise<AxiosResponse<R>> {
    const response = await this.client.post(path, body ? deeplySnakize(body) : undefined, { params })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return deeplyCamelize<any, R>(response)
  }

  protected async put<B, R = unknown, P = Record<string, unknown>>(path: string, body?: B, params?: P): Promise<AxiosResponse<R>> {
    const response = await this.client.put(path, body ? deeplySnakize(body) : undefined, { params })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return deeplyCamelize<any, R>(response)
  }

  protected async patch<B, R = unknown, P = Record<string, unknown>>(path: string, body?: B, params?: P): Promise<AxiosResponse<R>> {
    const response = await this.client.patch(path, body ? deeplySnakize(body) : undefined, { params })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return deeplyCamelize<any, R>(response)
  }

  protected async delete<R = unknown, P = Record<string, unknown>>(path: string, params?: P): Promise<AxiosResponse<R>> {
    const response = await this.client.delete(path, { params })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return deeplyCamelize<any, R>(response)
  }

  private createClient(csrfToken: string) {
    const csrfTokenFromHTML = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    return axios.create({
      headers: {
        common: {
          'X-CSRF-Token': csrfToken || csrfTokenFromHTML,
          'Content-Type': 'application/json',
        },
        'X-Locale': localeString(),
      },
    })
  }
}
